var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "confirmation-popup",
    {
      ref: "popup",
      attrs: {
        title: _vm.resource(
          "DmVisualizer_ScenarioDeactivationConfirmationPopup_Title"
        ),
        texts: {
          header: _vm.scenario.batchCancellationTextHeader,
          body: _vm.scenario.batchCancellationText
        }
      }
    },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-warning",
          on: {
            click: function($event) {
              return _vm.$emit("confirm")
            }
          }
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.resource(
                  "DmVisualizer_ScenarioDeactivationConfirmationPopup_ConfirmationButtonText"
                )
              ) +
              "\n    "
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }